import React, { useState } from "react";
import { Link } from "react-router-dom";
import { forgotPassword } from "../../services/api/userService";
import "../../styles/features/auth.css";

function ForgetPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      await forgotPassword({ email });
      setSent(true);
    } catch (err) {
      // The server answers 200 whether or not the email has an account, so the
      // only errors here are a bad request, rate limiting or the network.
      const status = err.response?.status;
      if (status === 429) {
        setError("Too many reset requests. Please wait a few minutes and try again.");
      } else {
        setError(
          "Failed to process request: " +
            (err.response?.data?.error || err.response?.data?.message || err.message)
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="auth-container">
        <div className="auth-form" style={{ textAlign: "center" }}>
          <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>📬</div>
          <h2>Check Your Email</h2>
          <p style={{ color: "#555", marginBottom: "1rem" }}>
            If an account exists for<br />
            <strong>{email}</strong>,<br />
            we sent it a link to reset your password.
          </p>
          <p style={{ color: "#555", fontSize: "0.9rem", marginBottom: "1.5rem" }}>
            The link works once and expires in 1 hour. Your current password
            keeps working until you choose a new one.
          </p>
          <Link
            to="/login"
            className="auth-button"
            style={{ display: "inline-block", textDecoration: "none" }}
          >
            Go to Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>Forgot Password</h2>
        <p style={{ color: "#555", marginBottom: "1.25rem", fontSize: "0.95rem" }}>
          Enter your registered email and we'll send you a link to reset your password.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="fp-email">Email Address</label>
            <input
              id="fp-email"
              name="email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setError(""); }}
              required
            />
          </div>
          <button type="submit" className="auth-button" disabled={isLoading}>
            {isLoading ? "Sending…" : "Send Reset Link"}
          </button>
        </form>

        {error && <div className="error-message">{error}</div>}

        <div className="auth-links">
          <Link to="/login">Remember your password? Login</Link>
          <br />
          <Link to="/register">Don't have an account? Register</Link>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
